import { createContext } from "react";
const SliderMultipageContext = createContext({});
export default SliderMultipageContext;
